// File path: src/project-portal/pages/Whatsapp/elements/WhatsappChatBox.js
import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  Slide,
  Box,
  Typography,
  IconButton,
  TextField,
  Avatar,
  Skeleton,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import MicIcon from "@mui/icons-material/Mic";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import VoiceRecorder from "../../Leads/FullDetailsPage/WhatsappChatBox/elements/VoiceRecorder";
import { WhatsappTemplatesAPI } from "../../../../api/Endpoints/WhatsappTemplateAPI";
import TemplateDropdown from "../../Leads/FullDetailsPage/WhatsappChatBox/TemplateDropdown";
import moment from "moment";
import Pusher from "pusher-js";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Fancybox, Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PreViewer from "../../Leads/FullDetailsPage/WhatsappChatBox/elements/PreViewer";
import PictureAsPdfIcon from "@mui/icons-material/InsertDriveFile"; // MUI PDF Icon
import PlayArrowIcon from "@mui/icons-material/PlayArrow"; // Import Play icon
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { HdrWeak } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  PictureAsPdf,
  Image,
  VideoLibrary,
  InsertDriveFile,
} from "@mui/icons-material";
import { set } from "nprogress";
import TemplatePreviewer from "./TemplatePreviewer/TemplatePreviewer";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const ChatBox = ({
  id,
  setId,
  Name,
  TableUpdate,
  phone_number,
  closeFromDetail,
  setRefresh
}) => {
  const [openDrp, setOpenDrp] = useState(false); // Chat box open state
  const [file, setFiles] = useState(); // Store uploaded files
  const [showVoiceMessage, setshowVoiceMessage] = useState(false); // Store voice messages
  const [open, setOpen] = useState(false); // Chat box open state
  const [templateContent, setTemplateContent] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const messagesEndRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sendTemplate, setSendTemplate] = useState(false);
  const [imageLoad, setImageLoad] = useState(false);
  const [previewrOpen, setPreviewrOpen] = useState(false);

  // Store chat messages
  let UserName = localStorage.getItem("UserName");
  const { watch, setValue } = useForm();
  const handleFileChange = (event) => {
    if (event.target.files.length === 0) return; // No file selected

    const selectedFile = event.target.files[0];

    setFiles(selectedFile); // Update state
    setPreviewrOpen(true); // Open preview

    event.target.value = ""; // Clear input to allow selecting the same file again
  };

  const [is24HoursPassed, setIs24HoursPassed] = useState(false);
  const [recording, setRecording] = useState(false);
  // Handle message send
  const handleSendMessage = async () => {
    if (inputMessage.trim() !== "") {
      const newMessage = {
        text: inputMessage,
        type: "sent",
        name: UserName,
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      setMessages((prevMessages) => {
        const updatedMessages = [...prevMessages, newMessage];
        setTimeout(() => {
          messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100); // Allow state update before scrolling
        return updatedMessages;
      });

      setInputMessage("");

      const messageContent = {
        to: phone_number,
        message: inputMessage,
        lead_id: id,
        msg_type: "Text",
      };

      try {
        const res = await WhatsappTemplatesAPI.sentMessage(messageContent);

        
      } catch (error) {
        
        console.error("Failed to send message:", error);
      }
    }
  };

  useEffect(() => {
    const pusher = new Pusher("e9821283ae4e0a5b1271", {
      cluster: "ap2",
      //   encrypted: true,
    });
    const channel = pusher.subscribe("desai-channel");
    channel.bind("desai-event", (data) => {
      console.log("Received message:", data);
      if (data?.lead_id == id) {
        fetchWhatsappMessages(true);
      }
    });
    return () => {
      pusher.unsubscribe("desai-channel");
      pusher.disconnect();
    };
  }, [id]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "instant" });
  }, [messages, loading]);

  const VoiceMessageClick = async () => {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    setshowVoiceMessage(!showVoiceMessage);
  };

  /*************  ✨ Codeium Command ⭐  *************/
  /**
 * Appends a new voice message to the chat history
/******  47e8905b-6590-4534-9e83-f9d315989688  *******/

  const handleImageClick = (src) => {
    Fancybox.show([
      {
        src: src,
        type: "image",
        zoom: true,
      },
    ]);
  };
  const hanldeVideoClick = (src) => {
    Fancybox.show([
      {
        src: src,
        type: "html5video",
        zoom: true,
      },
    ]);
  };

  const ffmpeg = new FFmpeg();

  async function convertToM4A(blobURL) {
    if (!ffmpeg.loaded) {
      await ffmpeg.load();
    }

    try {
      // Convert Blob URL to a Uint8Array
      const response = await fetch(blobURL);
      const audioBlob = await response.blob();
      const arrayBuffer = await audioBlob.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);

      // Write the WebM file to FFmpeg memory
      await ffmpeg.writeFile("input.webm", uint8Array);

      // Convert WebM to M4A
      await ffmpeg.exec(["-i", "input.webm", "-c:a", "aac", "output.m4a"]);

      // Read the converted file
      const m4aData = await ffmpeg.readFile("output.m4a");
      const m4aBlob = new Blob([m4aData.buffer], { type: "audio/mp4" });

      return new File([m4aBlob], "converted.m4a", { type: "audio/mp4" });
    } catch (error) {
      console.error("FFmpeg conversion failed:", error);
      throw error; // Ensure error is caught in the calling function
    }
  }

  const handleSendVoiceMessage = async (audioURL) => {
    setMessages([
      ...messages,
      {
        text: audioURL,
        type: "sent",
        msg_type: "Audio",
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      },
    ]);

    try {
      // Convert the Blob URL to a File object

      const file = await convertToM4A(audioURL); // Convert WebM to M4A

      const formData = new FormData();
      formData.append("audio", file); // Attach M4A file
      formData.append("to", phone_number);
      formData.append("lead_id", id);
      formData.append("msg_type", "Audio");
      // Send the FormData to the backend
      const res = await WhatsappTemplatesAPI.sentMessage(formData); // Use the correct API method

      if (res?.data.success) {
        TableUpdate && TableUpdate();
      }
      // Update the UI with the sent message
    } catch (error) {
      console.error("Error sending voice message:", error);
      
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";

    // Convert timestamp to Date object
    const date = new Date(timestamp);

    // Convert to local time
    const localTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return localTime.toLowerCase().replace(/\s/g, "");
  };

  const handleClose = () => {
    setshowVoiceMessage(false);
    setRecording(false);
    setPreviewrOpen(false);
    closeFromDetail && closeFromDetail();
    // TableUpdate && TableUpdate();
    setValue("template", null);
    setInputMessage("");
    setOpenDrp(false);
    setOpen(false);
    setId && setId(); // Call setId without parameter to close properly
 setRecording&&   setRefresh(Math.random);
  };


  useEffect(() => {
    if (id > 0) {
      setOpen(true);
      fetchWhatsappMessages();
    } else {
      setOpen(false); // Ensure dialog is closed when id is not valid
    }
  }, [id]);

  const onTemplateSend = async () => {
    setLoading(true);
    const MessageText = watch("template").components.find(
      (comp) => comp.type === "BODY"
    )?.text;
    const headerType = watch("template").components.find(
      (comp) => comp.type === "HEADER"
    )?.format;

    
    try {
      setSendTemplate(true);
      const messageContent = {
        to: phone_number,
        template_name: watch("template")?.name,
        message: MessageText,
        lead_id: id,
        language: "en_US",
        ...(headerType ? { header: [headerType.toLowerCase()] } : {}),
        header_type: headerType?.toLowerCase(),
        parameter_format:
          watch("template")?.parameter_format === "POSITIONAL"
            ? "POSITIONAL"
            : undefined,
      };

      const res = await WhatsappTemplatesAPI.sendTemplateForChat(
        messageContent
      );
      if (res) {
        fetchWhatsappMessages();
      }
      setSendTemplate(false);
      setValue("template", null);
      setOpenDrp(false);
      setTemplateContent(false);
      setLoading(false);
    } catch (error) {
      console.log(error);

      setSendTemplate(false);
      toast.error("Internal Server Error", { autoClose: 2000 });
      setLoading(false);
    }
  };

  const fetchWhatsappMessages = async (noLoad) => {
    if (!noLoad) {
      setLoading(true);
    }

    try {
      // Only fetch messages if we have a valid lead_id
      if (!id || id <= 0) {
        setMessages([]);
        setLoading(false);
        return;
      }

      const res = await WhatsappTemplatesAPI.getMessagesList({ lead_id: id });

      // Ensure data exists and map it into the required format
      const formattedMessages =
        res?.data?.map((item) => ({
          text: item.message, // Use 'message' from API response
          type: item.type === "send" ? "sent" : "received", // Adjust type
          time: formatTimestamp(item.created_at), // Format time
          created_at: item.created_at, // Keep original created_at for comparison
          msg_type: item.msg_type,
          name: item.name,
          mediaURL: item.media_url,
          read: item.wa_status 
        })) || [];


      // Check if 24 hours have passed since the last message
      const lastMessage = formattedMessages[formattedMessages.length - 1]; // Get the last message
   
      let is24HoursPassed = true;

      if (lastMessage) {
        const lastMessageTime = moment.utc(lastMessage.created_at);
        const now = moment.utc();
        is24HoursPassed = now.diff(lastMessageTime, "hours") >= 24;
      }

      // Update state
      setMessages(formattedMessages);
      setIs24HoursPassed(is24HoursPassed);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching WhatsApp messages:", error);
      setLoading(false);
    }
  };

  const checkExtansion = (url) => {
    if (!url) return "";
    const parts = url.split(".");
    if (parts.length < 2) return "";
    return parts.pop().toLowerCase();
  };

  const getFilePreview = (url, ext) => {
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
      return (
        <img
          src={url}
          alt="preview"
          style={{ width: 50, height: 50, borderRadius: 5 }}
        />
      );
    }
    if (["mp4", "avi", "mov"].includes(ext)) {
      return (
        <video width="50" height="50" controls>
          <source src={url} type={`video/${ext}`} />
          Your browser does not support the video tag.
        </video>
      );
    }
    if (ext === "pdf") {
      return <PictureAsPdf sx={{ color: "#FF5722", fontSize: 50 }} />;
    }
    return <InsertDriveFile sx={{ color: "#9E9E9E", fontSize: 50 }} />;
  };

  const FilePreview = ({ msg }) => {
    const ext = checkExtansion(msg.mediaURL);

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
          padding: "8px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        {/* File Preview */}
        <Avatar
          sx={{ bgcolor: "#fff", width: 50, height: 50, borderRadius: 2 }}
        >
          {getFilePreview(msg.mediaURL, ext)}
        </Avatar>

        {/* File Info */}
        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "#333",
              wordBreak: "break-word",
            }}
          >
            {msg.text}
          </Typography>
          <Typography sx={{ fontSize: "10px", color: "#666" }}>
            {ext.toUpperCase()}
          </Typography>
        </Box>
      </Box>
    );
  };

  const handlePreivew = () => {
    setTemplateContent(true);
  };
  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            width: "50%",
            height: "100%",
            position: "fixed",
            right: 0,
            top: 0,
            bottom: 0,
            m: 0,
            p: 0,
            borderRadius: 0,
            maxHeight: "100%",
            display: "flex",
            flexDirection: "column",
          },
        }}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {/* Header */}
        <Box
          className="user-title-block "
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            backgroundColor: "#f0f2f5",
            color: "#170E2B",
          }}
        >
          <div className="user-title ">
            <svg
              className="cursor-pointer"
              onClick={handleClose}
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_3450_281)">
                <path
                  d="M15.9453 8L3.00781 8L8.27344 2.73438L7.14844 1.60156L-0.0546881 8.79688L7.14844 16L8.27344 14.8672L3.00781 9.60156L15.9453 9.60156L15.9453 8Z"
                  fill="#0B0D23"
                />
              </g>
              <defs>
                <clipPath id="clip0_3450_281">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(16 16) rotate(180)"
                  />
                </clipPath>
              </defs>
            </svg>
            <Avatar alt="Remy Sharp" src="/broken-image.jpg">
              {Name?.substring(0, 1)}
            </Avatar>

            <Typography variant="h6">{Name || "Unknown User"}</Typography>
          </div>

          {/* <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton> */}
        </Box>

        {/* Chat Body with WhatsApp Wallpaper */}
        <Box
          className="chat-block-container"
          sx={{
            flexGrow: 1,
            p: 2,
            overflowY: "auto",
            backgroundImage:
              "url('https://www.transparenttextures.com/patterns/asfalt-light.png')",
            backgroundColor: "#F9F9F9",
            backgroundSize: "cover",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            // Show skeletons while loading
            <>
              {[...Array(5)].map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    mb: 2,
                    alignItems: index % 2 === 0 ? "flex-start" : "flex-end",
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    width={250}
                    height={50}
                    sx={{ borderRadius: 2 }}
                  />
                  <Skeleton
                    variant="text"
                    width={60}
                    height={10}
                    sx={{ mt: 1 }}
                  />
                </Box>
              ))}
            </>
          ) : messages?.length === 0 && file?.length === 0 ? (
            <Typography sx={{ textAlign: "center", color: "#777" }}>
              No messages yet
            </Typography>
          ) : (
            <>
              {messages &&
                messages.map((msg, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems:
                        msg.type === "sent" ? "flex-end" : "flex-start",
                      mb: 1,
                    }}
                  >
                    {msg.msg_type === "Audio" ? (
                      // Audio Message
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          position: "relative",
                        }}
                      >
                        <audio
                          preload="metadata"
                          controls
                          src={msg.text}
                          controlsList="nodownload"
                        />
                        <Typography
                          sx={{ fontSize: "12px", color: "#777", mt: 0.5 }}
                        >
                          {msg.type === "sent" && `${msg.name}, `}
                          {msg.time}
                        </Typography>
                      </Box>
                    ) : msg.msg_type === "Image" ? (
                      // Image Message
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems:
                            msg.type === "sent" ? "flex-end" : "flex-start",
                        }}
                      >
                        <img
                          src={msg.text}
                          alt="Sent Image"
                          onClick={() => handleImageClick(msg.text)}
                          style={{
                            maxWidth: "250px",
                            borderRadius: "8px",
                            boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                            cursor: "pointer",
                          }}
                        />

                        {/* <ImageViewer imageSrc={msg.text} thumbnailSrc={msg.text} /> */}
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#777",
                            mt: 0.5,
                            textAlign: "right",
                          }}
                        >
                          {msg.type === "sent" && `${msg.name}, `}
                          {msg.time}        {msg.type === "sent" ? (
  msg.read === "read" ? (
    <DoneAllIcon sx={{ fontSize: 15, color: 'blue' }} />
  ) : msg.read === "failed" ? (
    <ErrorOutlineIcon sx={{ fontSize: 15,color: 'red' }} />
  ) : (
    <DoneAllIcon sx={{ fontSize: 15 }} />
  )
) : null}

                        </Typography>
                      </Box>
                    ) : msg.msg_type === "Video" ? (
                      // Image Message

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems:
                            msg.type === "sent" ? "flex-end" : "flex-start",
                          position: "relative",
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-block",
                            maxWidth: "250px",
                            borderRadius: "8px",
                            boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                            cursor: "pointer",
                          }}
                          onClick={() => hanldeVideoClick(msg.text)}
                        >
                          <video
                            src={msg.text}
                            preload="metadata"
                            style={{
                              width: "100%",
                              borderRadius: "8px",
                            }}
                          />
                          {/* Play Icon Overlay */}
                          <Box
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              background: "rgba(0,0,0,0.5)",
                              borderRadius: "50%",
                              padding: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <PlayArrowIcon
                              sx={{ color: "#fff", fontSize: "32px" }}
                            />
                          </Box>
                        </Box>

                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#170E2B",
                            mt: 0.5,
                            textAlign: "right",
                          }}
                        >
                          {msg.type === "sent" && `${msg.name}, `}
                          {msg.time}        {msg.type === "sent" ? (
  msg.read === "read" ? (
    <DoneAllIcon sx={{ fontSize: 15, color: 'blue' }} />
  ) : msg.read === "failed" ? (
    <ErrorOutlineIcon sx={{ fontSize: 15,color: 'red' }} />
  ) : (
    <DoneAllIcon sx={{ fontSize: 15 }} />
  )
) : null}

                        </Typography>
                      </Box>
                    ) : msg.msg_type === "Document" ? (
                      // Audio Message
                      <a
                        href={msg.text}
                        style={{ textDecoration: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems:
                              msg.type === "sent" ? "flex-end" : "flex-start",
                            padding: "8px",
                            border: "1px solid #E8ECF4",
                            borderRadius: "8px",
                            backgroundColor: "#F9F9F9",
                            maxWidth: "250px",
                            boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              maxWidth: "100%",
                            }}
                          >
                            {/* Left side PDF Icon */}
                            <Avatar
                              sx={{
                                bgcolor: "#FF5722",
                                width: 32,
                                height: 32,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0, // Prevent icon from shrinking
                              }}
                            >
                              <PictureAsPdfIcon
                                sx={{ color: "#fff", fontSize: 20 }}
                              />
                            </Avatar>

                            {/* File Name with ellipsis if too long */}
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "#333",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                flexGrow: 1, // Allow text to take remaining space
                              }}
                            >
                              {msg.text ? msg.text.split("/").pop() : "Document"}{" "}
                              {/* Extract file name from URL */}
                            </Typography>
                          </Box>

                          {/* Timestamp */}
                          <Typography
                            sx={{ fontSize: "12px", color: "#777", mt: 0.5 }}
                          >
                            {msg.type === "sent" && `${msg.name}, `}
                            {msg.time}        {msg.type === "sent" ? (
  msg.read === "read" ? (
    <DoneAllIcon sx={{ fontSize: 15, color: 'blue' }} />
  ) : msg.read === "failed" ? (
    <ErrorOutlineIcon sx={{ fontSize: 15,color: 'red' }} />
  ) : (
    <DoneAllIcon sx={{ fontSize: 15 }} />
  )
) : null}

                          </Typography>
                        </Box>
                      </a>
                    ) : msg.msg_type === "Text/Attach" ? (
                      // Audio Message
                      <a
                        href={msg.mediaURL}
                        style={{ textDecoration: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start", // Align items to the left
                            padding: "10px",
                            border: "1px solid #E8ECF4",
                            borderRadius: "8px",
                            backgroundColor: "#F9F9F9",
                            maxWidth: "250px",
                            boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                          }}
                        >
                          {/* Top Section - Icon on Left */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1, // Space between icon and text
                              width: "100%",
                            }}
                          >
                            {/* Attachment Icon (Left) */}
                            <FilePreview
                              msg={{ mediaURL: msg.mediaURL, text: msg.text || "Attachment" }}
                            />
                          </Box>

                          {/* Bottom Section - Timestamp */}
                          <Box
                            display={"flex"}
                            width={"100%"}
                            justifyContent={"end"}
                          >
                            <Typography
                              sx={{ fontSize: "10px", color: "#777", mt: 0.5 }}
                            >
                              {msg.type === "sent" && `${msg.name}, `}
                              {msg.time}        {msg.type === "sent" ? (
  msg.read === "read" ? (
    <DoneAllIcon sx={{ fontSize: 15, color: 'blue' }} />
  ) : msg.read === "failed" ? (
    <ErrorOutlineIcon sx={{ fontSize: 15,color: 'red' }} />
  ) : (
    <DoneAllIcon sx={{ fontSize: 15 }} />
  )
) : null}

                            </Typography>
                          </Box>
                        </Box>
                      </a>
                    ) : (
                      // Text Message
                      <Box
                        sx={{
                          backgroundColor:
                            msg.type === "sent" ? "#d9fdd3" : "#fff",
                          padding: "10px 10px 8px 10px",
                          borderRadius:
                            msg.type === "sent"
                              ? "10px 10px 2px 10px"
                              : "10px 10px 10px 2px",
                          maxWidth: "260px",
                           display:msg.text && msg.text.length>24?'block':'flex',
                          gap:'5px',
                          wordWrap: "break-word",
                          boxShadow: "0px 1px .5px rgba(11,20,26,0.13)",
                        }}
                      >
                        <Typography sx={{ fontSize: "14px" }}>
                          {msg.text || ""}
                        </Typography>
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            justifyContent: "flex-end",
                            fontSize: "10px",
                            textAlign: "right",
                            color: "#777",
                            mt: 0.5,
                          }}
                        >
                          {msg.type === "sent" && `${msg.name}`}
                          {msg.time}
      {msg.type === "sent" ? (
  msg.read === "read" ? (
    <DoneAllIcon sx={{ fontSize: 15, color: 'blue' }} />
  ) : msg.read === "failed" ? (
    <ErrorOutlineIcon sx={{ fontSize: 15,color: 'red' }} />
  ) : (
    <DoneAllIcon sx={{ fontSize: 15 }} />
  )
) : null}


                        </Typography>
                      </Box>
                    )}
                  </Box>
                ))}

              {/* Display Uploaded Files */}
              {file && file.type && !previewrOpen && (
                <Box
                  sx={{ mb: 1, display: "flex", justifyContent: "flex-end" }}
                >
                  {file.type.startsWith("image") ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="Uploaded"
                      style={{ width: 150, borderRadius: 8 }}
                    />
                  ) : file.type.startsWith("video") ? (
                    <video
                      src={URL.createObjectURL(file)}
                      controls
                      style={{ width: 150, borderRadius: 8 }}
                    />
                  ) : (
                    <Typography>{file.name}</Typography>
                  )}
                </Box>
              )}
            </>
          )}

          <Box ref={messagesEndRef} />
        </Box>
        {file && previewrOpen && (
          <PreViewer
            file={file}
            setFile={setFiles}
            setPreviewrOpen={setPreviewrOpen}
            id={id}
            fetchWhatsappMessages={fetchWhatsappMessages}
            phone_number={phone_number}
          />
        )}
        {openDrp && (
          <TemplateDropdown
            open={openDrp}
            setOpen={setOpenDrp}
            watch={watch}
            setValue={setValue}
          />
        )}
        {/* Footer */}
        {!previewrOpen && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              borderTop: "1px solid #E8ECF4",
              backgroundColor: "#F9F9F9",
            }}
          >
            {/* Hidden File Input */}
            {!showVoiceMessage ? (
              <>
                {" "}
                <input
                  disabled={is24HoursPassed ? true : false}
                  type="file"
                  id="file-upload"
                  accept="image/,video/,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                {/* File Upload Button */}
                <IconButton
                  component="label"
                  htmlFor="file-upload"
                  disabled={is24HoursPassed ? true : false}
                >
                  <PermMediaIcon />
                </IconButton>
                <TextField
                  className="message-input"
                  fullWidth
                  placeholder={
                    is24HoursPassed
                      ? "24 hours passed. Click 'T' to select template"
                      : "Type a message"
                  }
                  disabled={
                    is24HoursPassed
                      ? true
                      : false || watch("template")?.name
                      ? true
                      : false
                  }
                  variant="outlined"
                  sx={{
                    mx: 1,
                    border: "0px",
                    backgroundColor: "rgba(153, 153, 153, 0.20)",
                    borderRadius: "20px",
                    color: "black",
                  }}
                  value={watch("template")?.name || inputMessage}
                  onChange={(e) => setInputMessage(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                />
                <IconButton
                  onClick={VoiceMessageClick}
                  disabled={is24HoursPassed ? true : false}
                >
                  <MicIcon />
                </IconButton>
                <IconButton onClick={() => setOpenDrp(true)}>
                  <TextFieldsIcon />
                </IconButton>
                <IconButton
                  onClick={openDrp ? handlePreivew : handleSendMessage}
                  disabled={sendTemplate ? true : false}
                >
                  <SendIcon />
                </IconButton>
              </>
            ) : (
              <Box sx={{ width: "100%" }}>
                <VoiceRecorder
                  startRecording={showVoiceMessage}
                  setshowVoiceMessageComponent={setshowVoiceMessage}
                  onSendVoiceMessage={handleSendVoiceMessage}
                  recording={recording}
                  setRecording={setRecording}
                />
              </Box>
            )}
          </Box>
        )}
{templateContent&&

        <TemplatePreviewer
          onSend={onTemplateSend}
          open={templateContent}
          setOpen={setTemplateContent}
          templateContent={watch("template")}
          loading={loading}
        />
}


      </Dialog>
    </>
  );
};

export default ChatBox;